import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { LocalStorageService } from 'src/app/_services/localStorage/local-storage.service';
import { AllocationService } from 'src/app/_services/resource-allocation/allocation.service';
import { ActivatedRoute, Router } from '@angular/router';
import { DatePipe } from '@angular/common';
import { UserService } from 'src/app/_services/user/user.service';
import { ColDef, ColumnApi, GridApi } from 'ag-grid-enterprise';
import { ExitProcessService } from 'src/app/_services/exit-process/exit-prosess.service';
import { printDiv } from './print-div';

@Component({
  selector: 'app-exit-form',
  templateUrl: './exit-form.component.html',
  styleUrls: ['./exit-form.component.scss']
})
export class ExitFormComponent implements OnInit {
  exitProcessForm;
  userClearanceForm;
  form: FormGroup;
  tenantId: string;
  currentUser: any;
  userDropdownList = [];
  userClearanceData: any[] = [];
  userClearance= [];
  userSeperationData: any[] = [];
  userSeperationDataObj: any;
  empInterviewDataObj: any;
  empInterviewDataObj2: any;
  userCreationForm
  defaultColDef:any;
  rowSelection:any
  dataSource: any;
  public columnDefs: ColDef[];
  sampleGridFrameworkComponents: any;
  private api: GridApi;
  private columnApi: ColumnApi;
  selectedRow: any;
  rowData: any;
  isHRAdmin: boolean;
  isFinanceAdmin: boolean;
  isITAdmin: boolean;
  resignationId: any;
  clearanceUserId: any;
  isManager: boolean;
  isDisabled: boolean = true;
  isVisible: boolean;
  isEmployeeFormVisible: boolean;
  exitStatus: any;
  isAckVisible: boolean;
  isTenantCustomised : boolean;
  hidePrintView: boolean = true;
  hidePrintBtn: boolean = false;
  reportingManagerClearanceData: any[] = [];
  isManagerCleared: any;
  itAdminClearanceData: any[] = [];
  itAdminCleared: any;
  financeAdminClearanceData: any[] = [];
  financeAdminCleared: any;
  hrAdminClearanceData: any[] = [];
  hrAdminCleared: any;
  ackDone: any[] = [];
  miscData: any[] = [];
  dateOfAck: any;

  constructor(
    private storageService: LocalStorageService,
    private router: Router,
    private route : ActivatedRoute,
    private snackBar: MatSnackBar,
    private formBuilder: FormBuilder,
    private exitProcessService: ExitProcessService,
    private userService: UserService,
  ) {
      this.route.queryParams.subscribe(params => {
        this.resignationId = params['resignationId'];
      });
      {
        this.defaultColDef = {
          flex: 1,
          minWidth: 100,
          resizable: true,
        };
      }
      
      this.exitProcessForm = this.formBuilder.group({
        userId: new FormControl({value: '', disabled: true}),
        userName: new FormControl({value: '', disabled: true}),
        localId: new FormControl({value: '', disabled: true}),
        resignationDate: new FormControl({value: '', disabled: true}),
        lastWorkingDate: new FormControl(''),
        expectedLastWorkingDate: new FormControl(''),
        alternateEmailId: new FormControl({value: '', disabled: true}),
        alternateContactNo: new FormControl({value: '', disabled: true}),
        reason: new FormControl({value: '', disabled: true}),
        comment: new FormControl({value: '', disabled: true}),
        currentDesignation: new FormControl({value: '', disabled: true}),
        joiningDate: new FormControl({value: '', disabled: true}),
        status: new FormControl(''),
        department: new FormControl({value: '', disabled: true}),
      });

      this.userClearanceForm = this.formBuilder.group({
        itemName: new FormControl({value: '', disabled: true}),
        status: new FormControl({value: '', disabled: true}),
        type: new FormControl({value: '', disabled: true}),
      });
    }

  ngOnInit(): void {
    this.tenantId = this.storageService.get('tenantId');
    this.currentUser = JSON.parse(this.storageService.get('currentUser'));
    this.isHRAdmin = this.currentUser.roles.includes('RoleHrmAdministrator');
    this.isFinanceAdmin = this.currentUser.roles.includes('RoleFinanceAdministrator') ;
    this.isITAdmin = this.currentUser.roles.includes('RoleITAdministrator') ;
    const customisedTenants = ['imtechnologies']
    this.isTenantCustomised = customisedTenants.includes(this.tenantId);
    if(this.isHRAdmin || this.isITAdmin || this.isFinanceAdmin){
      this.isVisible = true;
    }
    else{
      this.isVisible = false;
    }
    
    this.getUserSeparation(this.resignationId);

    if(!this.isHRAdmin){
      this.hidePrintBtn = true;
    }
  }

  printDiv(){
    this.hidePrintBtn = false;
    printDiv('clearanceForm');
    // TODO: Should be un-commented while enabling Print Button
    // const printBtn: HTMLElement = document.getElementById('print');
    // printBtn.onclick = function () {
    //    printDiv('clearanceForm');
    // };
  }

  printDivForm(){
    this.hidePrintBtn = false;
    printDiv('exitInterviewForm');
  }

  getEmployeeExitForm(){
    this.exitProcessService.getEmployeeExitForm(this.clearanceUserId).subscribe({
      next : (value: any) => {
        if(value.length > 0){
          this.empInterviewDataObj = value[0];
        }
      },
      error(err) {
        this.openSnackBar('ERROR: Getting Employee Interview Form Details' + err)
      },
      complete() {
      }
    }); 
  }

  getEmployeeInterviewForm(){
    this.exitProcessService.getEmployeeInterviewForm(this.clearanceUserId).subscribe({
      next : (value: any[]) => {
        if(value.length > 0){
          this.empInterviewDataObj2 = value[0];
        }
      },
      error(err) {
        this.openSnackBar('ERROR: Getting resignation' + err)
      },
      complete() {
      }
    });
  }
  
  getUserSeparation(resignationId){
    this.exitProcessService.getUserSeparationsById(resignationId).subscribe({
      next : (value: any) => {
        this.userSeperationData = value;
        this.userSeperationDataObj = value;
        this.clearanceUserId = value['userId'];
        this.exitStatus = value['status'];
        this.getUserById(value['userId']);
        this.getEmployeeExitForm();
        this.getEmployeeInterviewForm();
        if(value['status'] === 'Accepted'){
          this.isEmployeeFormVisible = true;
        }

        const clearanceData1 = this.userClearanceData.find(data => data.itemName === 'Clearance from Reporting Manager');
        const isDeptCleared = clearanceData1 ? clearanceData1.status === "Done" : null;

        const clearanceData2 = this.userClearanceData.find(data => data.itemName === 'Clearance From IT');
        const isITCleared = clearanceData2 ? clearanceData2.status === "Yes" : null;

        const clearanceData3 = this.userClearanceData.find(data => data.itemName === 'Clearance From Finance');
        const isFinanceCleared = clearanceData3 ? clearanceData3.status === "Yes" : null;

        const clearanceData4 = this.userClearanceData.find(data => data.itemName === 'Clearance From HR & Admin');
        const isHRCleared = clearanceData4 ? clearanceData4.status === "Yes" : null;
        
        if(isDeptCleared && isITCleared && isFinanceCleared && isHRCleared){
          this.isAckVisible === true
        }

        this.exitProcessForm.patchValue({
          userId: value['userId'] + ' . ' + value['userName'],
          localId: value['localId'],
          currentDesignation: value['currentDesignation'],
          resignationDate: value['resignationDate'],
          lastWorkingDate: value['lastWorkingDate'],
          expectedLastWorkingDate: value['expectedLastWorkingDate'],
          alternateEmailId: value['alternateEmailId'],
          alternateContactNo: value['alternateContactNo'],
          reason: value['reason'],
          comment: value['comment'],
          status: value['status'],
          joiningDate: value['dateOfJoining'],
          department: value['department'],
        });

        this.getUserClearance();
      },
      error(err) {
        this.openSnackBar('ERROR: Getting Resignation Details' + err);
      },
      complete() {
        // this.getUserClearance();
      }
    });
  }

  getUserById(selectedUserId) {
    this.userService.getUser(selectedUserId).subscribe({
      next: (response) => {
        if(this.exitStatus === 'Accepted'){
          if(selectedUserId === this.currentUser.id) {
            this.isDisabled = true;
          }
          else if(this.currentUser.id === response['supervisorId']){
            this.isManager = true;
            this.isDisabled = false;
          }
          else if(this.isHRAdmin) {
            this.isManager = false;
            this.isDisabled = false;
          }
          else{
            this.isManager = false;
            this.isDisabled = true;
          }
        }
        else{
          this.isManager = false;
          this.isDisabled = true;
        }
      },
      error: () => {

      },
      complete: () => {

      }
    })
  }

  getUserClearance(){
    this.exitProcessService.getAllUserClearanceByResignationIdId(this.resignationId).subscribe({
      next: (value: any) =>  {
        this.userClearanceData = value,
        this.userClearance = value

        // Filter Reporting Manager Data Only
        this.reportingManagerClearanceData = value.filter(
          item => item.clearanceType === 'ReportingManager' &&
          item.itemName !== 'Clearance from Reporting Manager' // exclude this from table
        );

        this.isManagerCleared = value.find(
          item =>
            item.clearanceType === 'ReportingManager' &&
            item.itemName === 'Clearance from Reporting Manager'
        )?.status;

        // Filter IT Data Only
        this.itAdminClearanceData = value.filter(
          item => item.clearanceType === 'IT' &&
          item.itemName !== 'Clearance From IT' // exclude this from table
        );

        this.itAdminCleared = value.find(
          item =>
            item.clearanceType === 'IT' &&
            item.itemName === 'Clearance From IT'
        )?.status;

        // Filter AccountsAndFinance Data Only
        this.financeAdminClearanceData = value.filter(
          item => item.clearanceType === 'AccountsAndFinance' &&
          item.itemName !== 'Clearance From Finance' // exclude this from table
        );

        this.financeAdminCleared = value.find(
          item =>
            item.clearanceType === 'AccountsAndFinance' &&
            item.itemName === 'Clearance From Finance'
        )?.status;

        // Filter HRAndAdmin Data Only
        this.hrAdminClearanceData = value.filter(
          item => item.clearanceType === 'HRAndAdmin' &&
          item.itemName !== 'Clearance From HR & Admin' // exclude this from table
        );

        this.hrAdminCleared = value.find(
          item =>
            item.clearanceType === 'HRAndAdmin' &&
            item.itemName === 'Clearance From HR & Admin'
        )?.status;

        // Filter EMP-ACK Data Only
        this.ackDone = this.userClearanceData.find(data => data.itemName === 'Acknowledgment by Employee');
        console.log("this.ackDone", this.ackDone);
        this.dateOfAck = this.ackDone ? this.ackDone['extraColumn1'] : null;

        // Filter Misc Data Only
        this.miscData = value.filter(
          item => item.clearanceType === 'Misc' &&
          item.itemName !== 'Acknowledgment by Employee' // exclude this from table
        );
        
      },
      error(error)  {
        this.openSnackBar('ERROR: Getting Resignation Details' + error);
      },
      complete(){

      }
    })
  }

  updateUserSeperation(){
    let details = {
      userId: this.exitProcessForm.get('userId').value.split(' . ')[0],
      userName: this.exitProcessForm.get('userId').value.split(' . ')[1],
      resignationDate: this.exitProcessForm.get('resignationDate').value,
      lastWorkingDate: this.exitProcessForm.get('lastWorkingDate').value,
      alternateEmailId: this.exitProcessForm.get('alternateEmailId').value,
      alternateContactNo: this.exitProcessForm.get('alternateContactNo').value,
      reason: this.exitProcessForm.get('reason').value,
      comment: this.exitProcessForm.get('comment').value,
      status: this.exitProcessForm.get('status').value
  }
  this.exitProcessService.editUserSeparations(details, this.resignationId).subscribe({
      next : (value) => {
        this.backToExit();
      },
      error(err) {
        this.openSnackBar('ERROR: Getting Resignation Details' + err);
      },
      complete() {
        // this.getUserClearance();
      }
    });
  }

  backToExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-process' ]);
  }

  openFinanceExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-finance' ], { queryParams: { resignationId: this.resignationId } });
  }

  openItHrmExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-hrit' ], { queryParams: { resignationId: this.resignationId } });
  }

  ExitEmployeeForm(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-employee-form'], {queryParams: {userId: this.currentUser.id}});
  }

  openDepartmentExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-department'], {queryParams: {resignationId: this.resignationId}});
  }

  openHrExit(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/exit-hr-admin'], {queryParams: {resignationId: this.resignationId}});
  }

  employeeAnknow(){
    this.router.navigate([ this.tenantId + '/dashboard/hr/exit-formalities/emply-anknowledge'], {queryParams: {resignationId: this.resignationId}});
  }
}
